import {select} from "bukku/shared/SagaService";
import { readLists } from "../Transaction/initTransaction/helper/readLists";
import { L } from "../List/reducer";
import dayjs from 'dayjs';
import Big from "big.js";
import { Float } from "../Transaction/calculation/helper";

function* setData(productId, type = 'SALE', unitId = null) {
    yield readLists([L.product_detail], {
        [L.product_detail]: {
            product_id: productId,
            type,
            date: dayjs().format("YYYY-MM-DD"),
        },
    });

    const productDetail = yield select(state => state.List.productDetail);

    const unit = productDetail.units?.find(unit => (unitId ? unit.id === unitId : unit.is_base));
    const unitPriceB = new Big(unit?.unit_price || 0);

    const dataIndex = type === 'SALE' ? 'sale_unit_price' : 'purchase_unit_price';

    return {
        product_unit_id: unit?.id,
        [dataIndex]: Float(unitPriceB),
    };
}

export function* getBundleItemDetail(productId, recordKey, unitId) {
    let item = {
        key: recordKey,
        product_id: productId,
    };
    const productList = yield select(state => state.List.productList);

    const p = productList.find(product => product.id === productId);

    const isSelling = p.is_selling;
    const isBuying = p.is_buying;

    if (isSelling) {
        const priceData = yield setData(productId, 'SALE', unitId);
        item = {
            ...item,
            ...priceData,
        };
    }

    if (isBuying) {
        const priceData = yield setData(productId, 'PURCHASE', unitId);
        item = {
            ...item,
            ...priceData,
        };
    }

    return {...item};
}
